import React, { useState } from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import FeedbackIcon from '@material-ui/icons/Feedback';
import DnsIcon from '@material-ui/icons/Dns';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MenuIcon from '@material-ui/icons/Menu';
import NoteIcon from '@material-ui/icons/Note';

const AdminNav = () => {
  const classes   = buildStyles();
  const [isCollapsed, setCollapsed]   = useState(false);

  return (
    <Grid item container className={clsx(classes.navWrapper, {"collapsed": isCollapsed})} direction="column" justifyContent="flex-start">
      
      <NavLink to="/app" className={classes.navItem} title="Back to the App"><ArrowBackIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Back"}</NavLink>
      
      <NavLink to="/admin" exact={true} className={classes.navItem} title="Dashboard"><DashboardIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Dashboard"}</NavLink>
      
      <NavLink to="/admin/users" exact={true} className={classes.navItem} title="Users"><PeopleIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Users"}</NavLink>
      
      <NavLink to="/admin/invitations" exact={true} className={classes.navItem} title="Invitations"><NoteIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Invitations"}</NavLink>
      
      <NavLink to="/admin/feedback" exact={true} className={classes.navItem} title="feedback"><FeedbackIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Feedback"}</NavLink>
      
      <NavLink to="/admin/waitlist" exact={true} className={classes.navItem} title="Waitlist"><ListAltIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Waitlist"}</NavLink>

      <NavLink to="/admin/auditlog" exact={true} className={classes.navItem} title="Audit Log"><DnsIcon fontSize="small" className={classes.navIcon}/>{isCollapsed ? "" : "Audit Log"}</NavLink>

      <IconButton size="small" className={classes.expandButton} onClick={() => setCollapsed(!isCollapsed)} title="Expand / Collapse Menu">
        <MenuIcon fontSize="small" />
      </IconButton>
    </Grid>
  );
}

export default AdminNav;

const buildStyles   = makeStyles(theme => ({
  navWrapper      : {
    // padding     : theme.spacing(2),
    marginTop  : theme.spacing(4),
    width       : 180,
    "&.collapsed" : {
      width   : 60,
    }
  },
  navItem   : {
    fontSize    : 14,
    fontWeight  : 600,
    color       : theme.palette.grey[800],

    marginBottom  : theme.spacing(2),
    padding       : theme.spacing(1), //`${theme.spacing(1)}px ${theme.spacing(1)}px`, //`,
    borderRadius  : "0 5px 5px 0", 
    textDecoration  : "none",
    "&:hover"   : {
      textDecoration  : "none",
      background    : `${theme.palette.grey[400]}44`, //`
    },
    "&.active"  : {
      color         : theme.palette.secondary.main,
      background    : `${theme.palette.secondary.light}44`, //`
    }
  },
  navIcon   : {
    marginRight   : theme.spacing(1),
    marginBottom  : `-${theme.spacing(1)}px`,   //`
  },
  disabled  : {
    color       : theme.palette.grey[400],
  },
  expandButton : {
    marginTop     : theme.spacing(2),
    alignSelf     : "flex-start",
    marginLeft    : theme.spacing(1),
  },
}));